import { scrollAnime } from "./components/scrollAnime";
import { humbergerMenuButton } from "./components/humbergerMenuButton";
import { accordion } from "./components/accordion";
import { tab } from "./components/tab";
import { slider } from "./components/slider";
import { inputError } from "./components/inputError";
import { megaMenu } from "./components/megaMenu";
import { pageTop } from "./components/pageTop";
import 'slick-carousel';
import 'slick-carousel/slick/slick.css'; // 追加
import 'slick-carousel/slick/slick-theme.css'; // 追加


$(document).ready(function () {

  (() => {
    /*
    アニメーション用関数
    */
    //アニメーション用クラスを定義
    const animeEl = ".u-anime";
    //スクロール時に付与されるクラス定義
    const addAnimeClass = "fadeIn";
    scrollAnime(animeEl, addAnimeClass);

  })();

  (() => {
    /*
    ハンバーガーメニュー用関数
    */
    //ハンバーガーメニューボタンクラス定義
    const buttonEl = "#humberge-button";
    //ハンバーガーメニュークラス定義
    const menuEl = "#humberge-menu";
    humbergerMenuButton(buttonEl, menuEl);
  })();

  (() => {
    /*
    スライダー用関数
    */
    const sliderEl = ".swiper";
    slider(sliderEl);
  })();

  (() => {
    /*
    アコーディオン用関数
    */
    //アコーディオンラッパークラス定義
    const accordionEl = ".accordion";
    //アコーディオンボタンクラス定義
    const accordionButtonEl = ".accordionButton";
    //アコーディオンアイテムクラス定義
    const accordionItemEl = ".accordionItem";
    accordion(accordionEl, accordionButtonEl, accordionItemEl);
  })();

  (() => {
    /*
    タブ用関数
    */
    //タブボタンラッパークラス定義
    const tabButtonEl = ".tabButton";
    //タブコンテンツラッパークラス定義
    const tabContentsEl = ".tabContent";
    tab(tabButtonEl, tabContentsEl);
  })();

  (() => {
    /*
    メガメニュー用関数
    */
    //メガメニューラッパークラス定義
    const megaMenuEl = "#megaMenu";
    //メガメニューナビアイテムクラス定義
    const megaMenuItemEl = ".megaMenuItem";
    //メガメニューコンテンツクラス定義
    const megaMenuContents = ".megaMenuContents";
    megaMenu(megaMenuEl, megaMenuItemEl, megaMenuContents);
  })();

  (() => {
    /*
    フォームバリデーション用関数
    */
    //フォームラッパークラス定義
    const formEl = ".p-form";
    //エラー表示用クラス定義
    const addErrorClass = "c-error";
    //WPなどでフォームから出力されるエラークラスを定義
    const errorEl = "error";
    inputError(formEl, addErrorClass, errorEl);
  })();

  (() => {
    /*
    ページトップボタン用関数
    */
    //ボタンクラス定義
    const pageTopButtonEl = "#pageTop";
    //初期状態を定義
    const hide = true;
    pageTop(pageTopButtonEl, hide);
  })();
  
});

// トップページスライダー
$(window).on('load',function(){
  $('.slick').on('init', function () {  
    $('.slick-slide[data-slick-index="0"]').addClass('slick-animation');})  
    .slick({    
      autoplay: true,    
      infinite: true,    
      fade: true,    
      dots: true,    
      slidesToShow: 1,    
      slidesToScroll: 1,    
      arrows: false,    
      speed: 2000,    
      autoplaySpeed: 7000,    
      pauseOnFocus: false,    
      pauseOnHover: false  
    });
  });


  //製品詳細のスライダー
  $(window).on('load',function(){
    $('#cfmainslide02').slick({
      arrows: true,
      prevArrow: '<img src="' + path + '/assets/images/common/icon_slidearrow-prev.svg" class="p-product__slide__prev slide-arrow prev-arrow">',
      nextArrow: '<img src="' + path + '/assets/images/common/icon_slidearrow-next.svg" class="p-product__slide__next slide-arrow next-arrow">',
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      speed: 1000,
      asNavFor: "#cfthumbslide"
    });

    $("#cfthumbslide").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      asNavFor: "#cfmainslide02",
      focusOnSelect: true,
      arrows: false,
      autoplaySpeed: 2500,
      speed: 1000,
    });
  });


  //
    $(window).on("scroll", function () {
    if($("#originmenu").length) {
      if($(window).scrollTop() > 100) {
        $('#originmenu').fadeOut();
        $('#fixmenutop').fadeIn();
      } else {
        $('#fixmenutop').fadeOut();
        $('#originmenu').fadeIn();
      }
    }
  });

  //ウィンドウスクロール時のサイドメニューの制御
  $(function() {
    var fixmenupc = $('#fixmenu-bottom');
    var fixmenusp = $('.p-fixmenu--fixed--sp');   
    var fixmenuclose = $('#fixmenu-close');  
    let in_h = window.innerHeight;
    var flag = '';
    // fixmenu.hide();
    // fixmenuclose.hide();

    const spsize = 768;
    //スクロールが100に達したらボタン表示 リサイズ時のボタンスタイル等調整
    $(window).on("scroll", function () {
      let windowWidth = $(window).width();
        if(windowWidth >= spsize) {
          if(fixmenupc.hasClass('active')) {
            if($('#toppage').length){
              if ($(this).scrollTop() > in_h) {
                fixmenusp.removeClass('show');
                fixmenuclose.fadeIn();
              } else {
                fixmenusp.removeClass('show');
                fixmenupc.fadeOut();
                fixmenuclose.fadeOut();
              }
            } else {
              if ($(this).scrollTop() > 100) {
                fixmenusp.removeClass('show');
                fixmenuclose.fadeIn();
              } else {
                fixmenusp.removeClass('show');
                fixmenupc.fadeOut();
                fixmenuclose.fadeOut();
              }
            }
          } else {
            if($('#toppage').length){
              if ($(this).scrollTop() > in_h) {
                fixmenusp.removeClass('show');
                fixmenupc.fadeIn();
              } else {
                fixmenusp.removeClass('show');
                fixmenupc.fadeOut();
                fixmenuclose.fadeOut();
              }
            } else {
              if ($(this).scrollTop() > 100) {
                fixmenusp.removeClass('show');
                fixmenupc.fadeIn();
              } else {
                fixmenusp.removeClass('show');
                fixmenupc.fadeOut();
                fixmenuclose.fadeOut();
              }
            }
          }
        } else {
          fixmenuclose.fadeOut();
          if ($(this).scrollTop() > 100) {
            fixmenusp.addClass('show');
            fixmenupc.fadeOut();
          } else {
            fixmenusp.removeClass('show');
            fixmenuclose.fadeOut();
            fixmenupc.fadeOut();
          }
        }
    });

    // ウィンドウリサイズ時のサイドメニューの表示制御
    $(window).on("resize", function () {
      let windowWidthcurrent = $(window).width();
      if(windowWidthcurrent >= spsize && flag != 'pc') {
        flag = 'pc';
        if($('#toppage').length){
          if ($(this).scrollTop() > in_h) {
            fixmenusp.removeClass('show');
            fixmenupc.fadeIn();
          } else {
            fixmenusp.removeClass('show');
            fixmenupc.fadeOut();
            fixmenuclose.fadeOut();
          }
        } else {
          if ($(this).scrollTop() > 100) {
            fixmenusp.removeClass('show');
            fixmenupc.fadeIn();
          } else {
            fixmenusp.removeClass('show');
            fixmenupc.fadeOut();
            fixmenuclose.fadeOut();
          }
        }
      } else if(windowWidthcurrent <= spsize && flag != 'sp') {
        flag = 'sp';
        fixmenuclose.fadeOut();
        if ($(this).scrollTop() > 100) {
          fixmenusp.addClass('show');
          fixmenupc.fadeOut();
        } else {
          fixmenusp.removeClass('show');
          fixmenuclose.fadeOut();
          fixmenupc.fadeOut();
        }
      }
    });
    
    // サイドナビ閉じるボタン押下時の処理
    // $(".clsebtn").on("click", function() {
    //   fixmenuclose.fadeIn();
    //   if($("#fixmenu-bottom").hasClass('active')) {
    //     $("#fixmenu-bottom").hide().removeClass('active');
    //     $("#fixmenu-bottom").fadeIn(400).removeClass('active');
    //     $(".p-fixmenu__closedbtn").removeClass('active', 3000);
    //   } else {
    //     $("#fixmenu-bottom").hide().removeClass('active');
    //     $("#fixmenu-bottom").fadeIn(400).addClass('active');
    //     $(".p-fixmenu__closedbtn").addClass('active', 3000);
    //   }
    // })
    $(".clsebtn").on("click", function() {
      fixmenuclose.fadeIn();
      if(fixmenupc.hasClass('active')) {
        fixmenupc.hide().removeClass('active');
        fixmenupc.fadeIn(400).removeClass('active');
        $(".p-fixmenu__closedbtn").removeClass('active', 3000);
        sessionStorage.removeItem(key);
      } else {
        fixmenupc.hide().removeClass('active');
        fixmenupc.fadeIn(400).addClass('active');
        $(".p-fixmenu__closedbtn").addClass('active', 3000);
        sessionStorage.setItem(key, value);
      }
    })
    const key = 'class';
    const value = 'active';
    const data = sessionStorage.getItem(key);
    if (fixmenupc) {
      if (data) {
        fixmenupc.hide().removeClass('active');
        fixmenupc.fadeIn(400).addClass('active');
        $(".p-fixmenu__closedbtn").addClass('active', 3000);
      }
    }
});

// $(function() {
//   const target = document.getElementById('fixmenu-bottom');
//   const button = document.getElementById('button');
//   const key = 'class';
//   const value = 'active';
//   const data = sessionStorage.getItem(key);

//   if (target && button) {
//     if (data) {
//       target.classList.add(value);
//     }

//     button.addEventListener('click', () => {
//       target.classList.toggle(value);

//       if (target.classList.contains(value)) {
//         sessionStorage.setItem(key, value);
//       } else {
//         sessionStorage.removeItem(key);
//       }
//     });
//   }
// });

// 言語スイッチャーのカスタム
$(function() {
  $(".lang-item-ja a").text("JP");
  $(".lang-item-en a").text("EN");
});

//ローディングアニメーション　初回訪問時のみ表示
$(function () {
  var webStorage = function () {
    if (sessionStorage.getItem('access')) {
      /*
        2回目以降アクセス時の処理
      */
      $("#splash").addClass('active');
    } else {
      /*
        初回アクセス時の処理
      */
      sessionStorage.setItem('access', 'true'); // sessionStorageにデータを保存
      $("#splash").delay(3000).fadeOut('slow');//ローディング画面を3秒（3000ms）待機してからフェードアウト
      $("#splash_logo").delay(1500).fadeOut('slow');//ロゴを1.5秒（1500ms）待機してからフェードアウト
    }
  }
  webStorage();
});

//TOPページお知らせのタブボタン
$(function() {
  $('.tabbtn').on('click', function() {
    $('.tabbtn, .p-top__news__body').removeClass('select');
  
    $(this).addClass('select');
     
    var index = $('.tabbtn').index(this);
    $('.p-top__news__body').eq(index).addClass('select');
  });
});

//スムーススクロール
$(function() {
  $('a[href^="#"]').on("click",function () {
    console.log("clicked");
    const speed = 600;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? "html" : href);
    let position = target.offset().top;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});


$(function() {
  $(".humberge-buttonorg").click(function () {//ボタンがクリックされたら
    $(".humberge-buttonorg").toggleClass('active');//ボタン自身に activeクラスを付与し
      $("#haader-nav--sporg").toggleClass('panelactive');//ナビゲーションにpanelactiveクラスを付与
          $("body").toggleClass("u-display--fixed");
  });
  $(".humberge-buttonfix").click(function () {//ボタンがクリックされたら
    $(".humberge-buttonfix").toggleClass('active');//ボタン自身に activeクラスを付与し
      $("#haader-nav--spfix").toggleClass('panelactive');//ナビゲーションにpanelactiveクラスを付与
      $("body").toggleClass("u-display--fixed");
  });
  
});

/*Dropdown Menu*/
$(function() {
  $('.p-productlist__spmenu').on("click",function () {
    $(this).find('.p-productlist__spmenu__list').slideToggle(300);
  });
  $('.p-productlist__spmenu').focusout(function () {
    $(this).find('.p-productlist__spmenu__list').slideUp(300);
  });

});
